export const MODAL_TYPES = {
  FORM: "FORM",
};
